import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { CookiesProvider } from 'react-cookie';
import { TracerxBrowserInstrumentation } from './components/common/tracerx-browser-resolver';
import LoadingScreen from './components/loading-screen';
import { PolicyProvider } from './components/policy-list/policy-context';
import ThemeLayout from './routes/index';

const queryClient = new QueryClient();

function App() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <TracerxBrowserInstrumentation />
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <PolicyProvider>
            <ThemeLayout />
          </PolicyProvider>
        </QueryClientProvider>
      </CookiesProvider>
    </Suspense>
  );
}

export default App;
